export default {
  getSectionLineItem: (state) => state.sectionLineItem,
};
